// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Din shop på en telefon',
    desktop: 'Din shop på en computer',
  },
  loading: 'Indlæser skærmbilledet',
  failed: 'Skærmbilledet kunne ikke indlæses.',
};
